import React from 'react';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import MultiRangeFilter from '../../../../../molecules/formMultiRange';
import { useYearsInCurrentCompanyFilter } from './useYearsInCurrentCompanyFilter';

export const YearsInCurrentCompanyFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit } = useYearsInCurrentCompanyFilter({
    setFilters,
  });

  const initialValue = value
    ? {
        min: value.years_in_current_company_gteq ?? 0,
        max: value.years_in_current_company_lteq ?? 41,
      }
    : null;

  return (
    <Formik
      initialValues={{ yearsInCurrentCompany: initialValue }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="yearsInCurrentCompany"
          title="Years in current company"
          min={0}
          max={41}
          component={MultiRangeFilter}
        />
      </Form>
    </Formik>
  );
};

YearsInCurrentCompanyFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

YearsInCurrentCompanyFilter.defaultProps = {
  value: null,
};
